<template>
  <router-link :to="{ name: 'boxEdit', params: { locale: i18n.locale, boxId: box.id }}" class="option mobile-hide">
    <i class="icon-kp-edit"></i> {{ $t('general.actions.edit') }} Box
  </router-link>
</template>

<script>
import i18n from '../../i18n';

export default {
  data() {
    return {
      i18n,
    };
  },
  props: [
    'box',
  ],
};
</script>



/** WEBPACK FOOTER **
 ** EditBox.vue?28869fe5
 **/